import {
  NumberOrNullOrUndefined,
  BooleanOrNullOrUndefined,
} from 'src/app/shared/utils';

export class PatientMonthlyStatus {
  id?: number;
  patient_id?: number;
  month?: number;
  year?: number;
  received?: boolean;
  sent?: boolean;
  created_at?: string | Date;
  updated_at?: string | Date;
  deleted_at?: string | Date;

  constructor(data?: Partial<PatientMonthlyStatus>) {
    Object.assign(this, data);
  }

  static build = (
    data: Partial<PatientMonthlyStatus>,
  ): PatientMonthlyStatus => ({
    ...data,
    id: NumberOrNullOrUndefined(data.id),
    patient_id: NumberOrNullOrUndefined(data.patient_id),
    month: NumberOrNullOrUndefined(data.month),
    year: NumberOrNullOrUndefined(data.year),
    received: BooleanOrNullOrUndefined(data.received),
    sent: BooleanOrNullOrUndefined(data.sent),
    created_at: data.created_at ? new Date(data.created_at) : undefined,
    updated_at: data.updated_at ? new Date(data.updated_at) : undefined,
    deleted_at: data.deleted_at ? new Date(data.deleted_at) : undefined,
  });
}

export interface ParentsMonthlyStatusResponse {
  patient_id: number;
  communications: PatientMonthlyStatus[];
}

